;(function () {
  // 存多个 Swiper 实例
  const popularProductsSwipers = new Map();

  const initSlider = (slider) => {
    
    if (!slider || popularProductsSwipers.has(slider)) return;
    
    
    slider.classList.add('swiper');

    const wrapper = slider.querySelector('.popular-products__wrapper');
    if (!wrapper) return;

    wrapper.classList.add('swiper-wrapper');

    const slides = slider.querySelectorAll(
      '.popular-products__item, .popular-products__item_placeholder'
    );
    if (!slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });
    
    const swiperInstance = new Swiper(slider, {
      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 1000,
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
				el: slider.querySelector('.yg-slide-pagination'),
				clickable: true,
			},
    });

    // 保存实例
    popularProductsSwipers.set(slider, swiperInstance);
  };

  const destroySlider = (slider) => {
    if (!slider || !popularProductsSwipers.has(slider)) return;

    const swiperInstance = popularProductsSwipers.get(slider);
    if (swiperInstance && swiperInstance.destroy) {
      swiperInstance.destroy(true, true);
    }

    const wrapper = slider.querySelector('.popular-products__wrapper');
    const slides = slider.querySelectorAll(
      '.popular-products__item, .popular-products__item_placeholder'
    );

    slider.classList.remove('swiper');
    wrapper?.classList.remove('swiper-wrapper');
    slides.forEach((slide) => slide.classList.remove('swiper-slide'));

    popularProductsSwipers.delete(slider);
  };

  const initPopularProducts = (section) => {
    if (!section || !section.classList.contains('popular-products-section')) return;

    const sliders = section.querySelectorAll('.popular-products-slider');
    
    
    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const sectionWidth = entry.contentRect.width;

        sliders.forEach((slider) => {
          if (sectionWidth < 576) {
            initSlider(slider);
          } else {
            destroySlider(slider);
          }
        });
      });
    });

    observer.observe(section);
  };

  // 初始化当前 section
  const currentSection = document.currentScript?.parentElement;
  if (currentSection?.classList.contains('popular-products-section')) {
    initPopularProducts(currentSection);
  }

  // 监听动态加载 section
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target?.classList.contains('popular-products-section')) {
      initPopularProducts(e.target);
    }
  });
})();
